import { render } from "./PatientsDatatableTDPhone.vue?vue&type=template&id=0bd9477a"
import script from "./PatientsDatatableTDPhone.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__